<template>
  <div class="slides__content">
    <div class="grid">
      <div class="grid__column--six">
        <div class="form__group">
          <label class="form__label" for="duration">Trajanje u sekundama:</label>
          <input type="number" min="0" name="duration" v-model="activeSlide.additionals.duration"/>
        </div>

        <div class="form__group">
          <button type="button" class="btn btn--primary mt1" v-if="activeSlide.id" @click="submitSlide">UPDATE SLIDE</button>
          <button type="button" class="btn btn--primary mt1" v-else @click="submitSlide">PUBLISH</button>

          <button type="button" class="btn btn--danger mt1" v-if="activeSlide.id" v-on:click="$emit('deleteSlide')">DELETE</button>
        </div>
      </div>
      <div class="grid__column--six">
        <div class="form__group">
          <UploadImage :image.sync="activeSlide.media" :canSelectFiles="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from '@/components/Utils/UploadImage'
import Slide from '@/model/Slide'
import displayError from '@/helpers/displayError'

export default {
  components: {
    UploadImage
  },
  props: {
    slider: {
      type: Object,
      defulat: {}
    },
    activeSlide: {
      type: Object,
      defulat: {
        additionals: {}
      }
    },
    slides: {
      type: Array,
      defulat: []
    }
  },
  methods: {
    submitSlide () {
      axios.post(`/sliders/${this.$route.params.id}/change_updated_at`)

      if (this.activeSlide.id) {
        let allPromieses = []

        this.slides.forEach((slide) => {
          slide['order'] = this.slides.indexOf(slide) + 1
          allPromieses.push(Slide.update(this.$route.params.id, slide))
        })

        axios.all(allPromieses).then(axios.spread(() => {
          this.$snotify.success('Successfully updated.')
        }))
      } else {
        Slide.create(this.$route.params.id, this.activeSlide).then((response) => {
          this.$snotify.success('Successfully created.')
          this.activeSlide = response.data.data
        }).catch((error) => {
          displayError(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Screen/Screen.vue